import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-369" data-mp="185gce59eo0oo">
      <div className="mx-auto max-w-4xl" data-id="element-370" data-mp="1c578mohpb90l">
        <SectionHeading eyebrow="I built it around 6 core systems" title={<>Six practical <em className="text-gold-dark" data-id="element-372" data-mp="1zw4epkmtfc3x">volumes.</em> One system.</>} data-id="element-371" data-mp="1c608d5i8sy98" />
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-ink/70" data-id="element-373" data-mp="24tw344o94g3d">
          Instead of giving you hundreds of disconnected templates, I organized everything into six practical volumes.
        </p>

        <div className="mt-12 space-y-6" data-id="element-374" data-mp="1vserozlsh2l0">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl bg-cream ring-1 ring-ink/10" data-id="element-375" data-mp="feom1of0u699">
              <div className="flex items-center gap-4 px-5 py-4 sm:px-8" style={{
            backgroundColor: v.accent
          }} data-id="element-376" data-mp="kekpnmjt3voa">
                <span className="font-serif text-4xl font-black leading-none text-white/90" data-id="element-377" data-mp="3o97xgglfyeqb">{String(v.number).padStart(2, '0')}</span>
                <div data-id="element-378" data-mp="3jawrwi26iqdw">
                  <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/75" data-id="element-379" data-mp="20ylpn4ga9iw">Volume {v.number}</p>
                  <h3 className="font-serif text-2xl sm:text-3xl font-black leading-tight text-white" data-id="element-380" data-mp="3t7jbz4moldev">{v.title}</h3>
                </div>
              </div>
              <div className="p-5 sm:p-8" data-id="element-381" data-mp="aztv182sjzqf">
                <p className="font-serif text-xl sm:text-2xl font-bold leading-snug text-ink" data-id="element-382" data-mp="633e6ij5x03y">{v.headline}</p>
                <p className="mt-3 text-[17px] leading-relaxed text-ink/70" data-id="element-383" data-mp="krpscgx1zltl">{v.intro}</p>

                <p className="mt-6 text-sm font-bold uppercase tracking-wider text-ink/50" data-id="element-384" data-mp="frtnygkg1sdi">Inside you’ll find</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-385" data-mp="trcx9cozr9re">
                  {v.items.map(item => <li key={item} className="flex gap-2.5" data-id="element-386" data-mp="prud4j4zv2pm">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" strokeWidth={3} aria-hidden="true" data-id="element-387" data-mp="wu984kcpmris" />
                      <span className="text-[16px] font-medium text-ink" data-id="element-388" data-mp="11tvkkrkps3qj">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-6 flex gap-3 rounded-2xl bg-white p-4 ring-1 ring-gold/40" data-id="element-389" data-mp="16q2h5tr802vt">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-390" data-mp="1bkgisdwh768x" />
                  <p className="text-[16px] leading-snug text-ink" data-id="element-391" data-mp="1fml6kw08t8nn">
                    <strong data-id="element-392" data-mp="1khqtny5dstdb">My goal:</strong> {v.goal}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta label="I want all 6 volumes now" data-id="element-393" data-mp="1ui145b017mos" />
      </div>
    </section>;
}